import { FormEvent, useEffect, useState } from "react";

const MAX = 140;
// Mirrors the global cooldown enforced by database.rules.json on /data writes.
export const POST_COOLDOWN_MS = 10000;

export function Input({
  onSubmit,
  initial,
  postedAt,
}: {
  onSubmit: (value: string) => void;
  initial?: string;
  postedAt?: number;
}) {
  const [local, setLocal] = useState("");
  const [now, setNow] = useState(() => Date.now());

  const cooldownUntil = postedAt ? postedAt + POST_COOLDOWN_MS : 0;
  const remainingMs = Math.max(0, cooldownUntil - now);
  const cooling = remainingMs > 0;
  const remainingSec = Math.ceil(remainingMs / 1000);

  useEffect(() => {
    if (!cooling) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [cooling]);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (cooling) return;
    const v = local.trim();
    if (!v) return;
    onSubmit(v);
    setLocal("");
  }

  const n = local.length;
  const warn = n > 110;

  return (
    <form className="compose-line" autoComplete="off" onSubmit={handleSubmit}>
      <span className="compose-cue" aria-hidden="true">
        your turn
      </span>
      <label className="compose-field">
        <input
          type="text"
          maxLength={MAX}
          placeholder={
            cooling
              ? `cooldown — ${remainingSec}s until you can post`
              : "say something worth reading…"
          }
          value={local}
          onChange={(e) => setLocal(e.target.value)}
          disabled={cooling}
          autoFocus={!cooling}
        />
        <span className={`count${warn ? " warn" : ""}`}>
          {n}/{MAX}
        </span>
      </label>
      <button
        className="compose-go"
        type="submit"
        disabled={cooling || !local.trim()}
        title={cooling ? `wait ${remainingSec}s` : "replaces it for everyone"}
      >
        {cooling ? `wait ${remainingSec}s` : "replace it ↵"}
      </button>
    </form>
  );
}
